import { call, put, takeEvery } from 'redux-saga/effects'
import * as actionNotification from 'actions/notifications'
import * as action from 'actions'
import * as apiUsers from 'api/users'
import {
  FORGOT_PASSWORD
} from 'actions/constants'
import { browserHistory } from 'react-router'
import * as mpForgotPass from 'mixpanel/forgot'

export function * forgotPasswordFlow (request) {
  yield put(action.sendingRequest(true))
  yield put(action.showProgressBar())
  let {email} = request.payload.data
  try {
    yield call(apiUsers.forgotPassword, {email})
    yield put(action.changeFormForgot({email}))
    browserHistory.push('/success-forgot-password')
  } catch (error) {
    yield put(actionNotification.error(error.message))
  } finally {
    yield put(action.hideProgressBar())
    yield put(action.sendingRequest(false))
  }
  mpForgotPass.forgotPasswordStart({
    email: email
  })
}

export default function * saga () {
  yield takeEvery(FORGOT_PASSWORD, forgotPasswordFlow)
}



// WEBPACK FOOTER //
// ./app/sagas/forgotPassword/forgotPassword.js